import type React from 'react'

import {
  CopywriterBadge,
  ReadOnlyBadge,
  TemplateBadge,
  TrialBadge,
} from './components'

interface Props {
  readOnly: boolean
  trial: boolean
  copywriterMode: boolean
  template: boolean
}

export const ProjectBadge: React.FC<Props> = ({
  readOnly,
  trial,
  copywriterMode,
  template,
}) => {
  if (template) {
    return <TemplateBadge />
  }

  if (copywriterMode) {
    return <CopywriterBadge />
  }

  if (readOnly) {
    return <ReadOnlyBadge />
  }

  if (trial) {
    return <TrialBadge />
  }

  return null
}
